import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { Box, Typography } from "@mui/material";

const SubscriberPieChart = ({ data }) => {
  // Create a chart-ready array from the data prop
  const pieChartData = [
    // var storedValue = typeof data.free_subscribers !== 'undefined' ? data.free_subscribers : "...";
    {
      name: "Free",
      value: data.free_subscribers,
      color: "#FFBB28",
    },
    {
      name: "Paid",
      value: data.paid_subscribers,
      color: "#FF8042",
    },
  ];

  return (
    <Box m="1vw">
      <Typography variant="h6" color="var(--white)" fontWeight={600}>
        Subscriber Type
      </Typography>
      <Box display="flex" width="100%">
        <Box width="75%">
          <ResponsiveContainer width="99%" height={235}>
            <PieChart>
              <Tooltip
                contentStyle={{ background: "white", borderRadius: "5px" }}
              />
              <Pie
                data={pieChartData}
                innerRadius={"65%"}
                outerRadius={"85%"}
                paddingAngle={5}
                dataKey="value"
              >
                {pieChartData.map((item) => (
                  <Cell key={item.name} fill={item.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          gap="10px"
          fontSize="14px"
        >
          {pieChartData.map((entry) => (
            <Typography
              display="flex"
              alignItems="center"
              key={entry.name}
              color="var(--white)"
            >
              <Box
                width="10px"
                height="10px"
                borderRadius="50%"
                backgroundColor={entry.color}
                mr="10px"
              />
              {`${entry.name}: ${entry.value}`}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SubscriberPieChart;
